module.exports = __webpack_public_path__ + "static/media/Bookhive.91370b51.PNG";